import "./Home.css"


function Home() {
    return <header className="img">
        <img src={require("../assets/Images/inicio.png")} alt='Org' />
    </header>
}

export default Home